// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchSeriesView__breadCrumbs"};